import { BaseRepository } from './BaseRepository';
import Patient, { IPatient, PatientToUpdate } from '../models/Patient';
import { Appointment } from '../models';
import { createFormData } from '../utils/createFormData';
import handleResponseError from './utils/handleResponseError';

export default class PatientRepository extends BaseRepository<Patient> {
  static findAll(): Promise<Patient[]> {
    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...this.authHeader()
      }
    };

    return fetch(`${this.apiUrl}/patient`, requestOptions)
      .then(this.handleResponse)
      .then(({ data }) => {
        return data.map((item: IPatient) => Patient.createFromEntity(item));
      });
  }

  static create(patient: Patient) {
    let formData = createFormData(patient.toEntity());

    const requestOptions = {
      method: 'POST',
      headers: {
        // 'Content-Type': 'application/json',
        ...this.authHeader()
      },
      body: formData
    };

    return fetch(`${this.apiUrl}/patient`, requestOptions)
      .then(this.handleResponse)
      .then(({ data }) => {
        return Patient.createFromEntity(data);
      });
  }

  static update(patient: PatientToUpdate): Promise<Patient> {
    let formData = createFormData(patient.toEntity());
    formData.append('_method', 'PUT');

    const requestOptions = {
      method: 'POST',
      headers: {
        // 'Content-Type': 'application/json',
        ...this.authHeader()
      },
      body: formData
    };

    return fetch(`${this.apiUrl}/patient/${patient.id}`, requestOptions)
      .then(this.handleResponse)
      .then(({ data }) => {
        return Patient.createFromEntity(data);
      });
  }

  static delete(patient: Patient) {
    const requestOptions = {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        ...this.authHeader()
      }
    };

    return fetch(`${this.apiUrl}/patient/${patient.id}`, requestOptions)
      .then(this.handleResponse)
      .then((res) => {
        return true;
      })
      .catch((e) => {
        return false;
      });
  }

  static async getAppointments(): Promise<Appointment[]> {
    const patients = await this.findAll();

    const appointments = patients
      .map((patient) => {
        patient.appointments.forEach(
          (appointment) => (appointment.patient = patient)
        );

        return patient.appointments;
      })
      .flat();

    appointments.sort(
      (a, b) => b.getStartDate().getTime() - a.getStartDate().getTime()
    );

    return appointments;
  }

  static handleResponse(response: Response) {
    return response.text().then((text: string) => {
      const res = text && JSON.parse(text);
      if (!response.ok) {
        if (response.status === 401) {
        }

        const error = (res && res.message) || response.statusText;
        let errorString = '';

        if (res.errors) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          for (let [key, value] of Object.entries(res.errors)) {
            errorString += `${value}<br/><br/>`;
          }
        }

        handleResponseError(response, res, errorString || error);
        return Promise.reject(error);
      }

      return res;
    });
  }
}
